import { Icons } from '@/components/Shares/Icons';
import { useAuth } from '@/providers/AuthProvider';
import { EXTENSION, useChat } from '@/providers/ChatProvider';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { useLingui } from '@lingui/react';
import { ActionIcon, Box, Button, Group, Input, Stack, Text } from '@mantine/core';
import { useState } from 'react';
import classes from './Aside.module.css';
import { AsideChatModal } from './AsideChatModal';
import { AsideCommand } from './AsideCommand';
import { AsideRain } from './AsideRain';
import { ChatActionButton } from './ChatActionButton';
import { EmojiPicker } from './EmojiPicker';
import { StickerList } from './StickerList';
export const AsideLogin: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    isLogin
  } = useAuth();
  const {
    setOpenModal
  } = useModalAction();
  const {
    activeExtension,
    setActiveExtension
  } = useChat();
  const [chat, setChat] = useState<string>('');
  const handleChat = (text: string) => {
    console.log(text);
    setChat('');
  };
  return <Box p="xs" pos="absolute" inset="auto 0px 0px" bg="var(--navbar-bg-color)">
      <AsideChatModal active={activeExtension === EXTENSION.RAIN}>
        <AsideRain />
      </AsideChatModal>
      <AsideChatModal active={activeExtension === EXTENSION.STICKER} onClickOutside={() => setActiveExtension(null)}>
        <StickerList />
      </AsideChatModal>

      <AsideChatModal active={activeExtension === EXTENSION.COMMAND} onClickOutside={() => setActiveExtension(null)}>
        <AsideCommand />
      </AsideChatModal>

      {isLogin ? <Stack gap={0}>
          <Input value={chat} onChange={event => setChat(event.currentTarget.value)} placeholder={i18n._('Say something...')} classNames={{
        input: classes.input
      }} h={40} leftSection={<EmojiPicker />} rightSection={<ActionIcon type="submit" variant="transparent" style={{
        pointerEvents: 'auto'
      }} onClick={() => handleChat(chat)}>
                <Icons className="icon-pr-flat-send" fontSize={20} color="var(--text-grey-2)" />
              </ActionIcon>} />

          <Group gap={10}>
            <ChatActionButton iconName="icon-pr-line-sticker" active={activeExtension === EXTENSION.STICKER} handleClick={() => setActiveExtension(EXTENSION.STICKER)} />

            <ChatActionButton iconName="icon-pr-line-rain" active={activeExtension === EXTENSION.RAIN} handleClick={() => setActiveExtension(EXTENSION.RAIN)} />

            <ChatActionButton iconName="icon-pr-line-command" active={activeExtension === EXTENSION.COMMAND} handleClick={() => setActiveExtension(EXTENSION.COMMAND)} />

            <ChatActionButton iconName="icon-pr-line-info" active={activeExtension === EXTENSION.RULES} handleClick={() => {
          setActiveExtension(EXTENSION.RULES);
          setOpenModal(MODAL.CHAT_RULES);
        }} />
          </Group>
        </Stack> : <Button bg="var(--button-bg-color)" fullWidth radius="sm" onClick={() => setOpenModal(MODAL.LOGIN)}>
          <Text tt="uppercase" fw="bold" fz="xs" c="var(--text-dark)">
            {i18n._('Log in to chat')}
          </Text>
        </Button>}
    </Box>;
};